import { render, staticRenderFns } from "./GdCameraList.vue?vue&type=template&id=64766ee8&scoped=true"
import script from "./GdCameraList.vue?vue&type=script&lang=js"
export * from "./GdCameraList.vue?vue&type=script&lang=js"
import style0 from "./GdCameraList.vue?vue&type=style&index=0&id=64766ee8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64766ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64766ee8')) {
      api.createRecord('64766ee8', component.options)
    } else {
      api.reload('64766ee8', component.options)
    }
    module.hot.accept("./GdCameraList.vue?vue&type=template&id=64766ee8&scoped=true", function () {
      api.rerender('64766ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/gdCamera/GdCameraList.vue"
export default component.exports